// extracted by mini-css-extract-plugin
export default {"root":"NftChips-module__root","nft":"NftChips-module__nft","image":"NftChips-module__image","name":"NftChips-module__name","expander":"NftChips-module__expander"};